<template>
    <p>
        <b v-if="title">{{ title }}</b>
        <slot></slot>
    </p>
</template>

<script>
export default {
    name: "Info",
    props: {
        title: {
            type: [String, Boolean],
            default: () => false
        }
    }
};
</script>

<style scoped>
p {
    margin: 0 0 0 5px;
    border-left: 1px solid;
    padding-left: 5px;
    max-width: 420px;
}
</style>
